import FeatureList from 'components/new/FeatureList'
import HeroPricing from 'components/new/HeroPricing'
import TrustedBrands from 'components/new/TrustedBrands'

export const CouponCenter = () => {
  return (
    <>
      <HeroPricing />

      <TrustedBrands />

      <FeatureList />
    </>
  )
}
